module.exports = __webpack_public_path__ + "img/button_submit.3ddbe328.svg";